var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseMessaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 24l-1.316-.75 2.066-3h3V15h-9v5.25h3v1.5h-3c-.827 0-1.5-.673-1.5-1.5V15c0-.827.673-1.5 1.5-1.5h9c.827 0 1.5.673 1.5 1.5v5.25c0 .827-.673 1.5-1.5 1.5h-2.25L17.25 24z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 1.5c-3.973 0-8.25.939-8.25 3V18c0 1.802 3.271 2.747 6.75 2.955v-1.5C4.85 19.243 3.1 18.354 3 18v-2.68c1.28.643 3.23 1.009 5.25 1.13v-1.496C4.85 14.744 3.1 13.856 3 13.5v-2.68C4.596 11.622 7.232 12 9.75 12c3.973 0 8.25-.94 8.25-3V4.5c0-2.062-4.277-3-8.25-3zM2.999 4.511C3.113 4.095 5.362 3 9.75 3c4.348 0 6.596 1.076 6.748 1.5-.152.424-2.4 1.5-6.748 1.5-4.388 0-6.637-1.095-6.751-1.489zM16.5 8.991c-.12.417-2.369 1.509-6.75 1.509C5.362 10.5 3.113 9.405 3 9V6.32c1.596.801 4.232 1.18 6.75 1.18s5.154-.379 6.75-1.18v2.67z",
    fill: "#45464F"
  })));
}
export default SvgDatabaseMessaging;